const Funfact = () => {
    return (
      <section className="revamp-funfact">
          <div className="container">
              <div className="row">
                  <div className="col-6 col-md-3">
                      <div className="revamp-funfact-item revamp-reveal">
                          <div className="icon">
                              <i className="fal fa-gem"></i>
                          </div>
                          <h3>68</h3>
                          <p>Projects Completed</p>
                      </div>
                  </div>
                  <div className="col-6 col-md-3">
                      <div className="revamp-funfact-item revamp-reveal">
                          <div className="icon">
                              <i className="fas fa-users"></i>
                          </div>
                          <h3>183</h3>
                          <p>Students</p>
                      </div>
                  </div>
                  <div className="col-6 col-md-3">
                      <div className="revamp-funfact-item revamp-reveal">
                          <div className="icon">
                              <i className="fas fa-address-book"></i>
                          </div>
                          <h3>127</h3>
                          <p>Clients</p>
                      </div>
                  </div>
                  <div className="col-6 col-md-3">
                      <div className="revamp-funfact-item revamp-reveal">
                          <div className="icon">
                              <i className="fal fa-trophy-alt"></i>
                          </div>
                          <h3>5</h3>
                          <p>Awards Winning</p>
                      </div>
                  </div>
              </div>
          </div>
      </section>
    );
  };
  
  export default Funfact;